import React from "react";

function TextData({ value }) {
  return <p>{value}</p>;
}

export default TextData;
